'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

var Map = React.createClass({
  render: function () {
    return (
      <div className="component-SimpleCom">
        <img width="100%" height="100%" src={assetsHelper.getComponentAsset('map')} alt=""/>
      </div>
    )
  }
});

module.exports = Map;



// WEBPACK FOOTER //
// ./src/views/Components/Map.jsx